// Fonte única de verdade para cores padrão do sistema.
// Usado em tenant.ts (geração de CSS) e nos presets de nova tenant.
export const TENANT_DEFAULT_COLORS = {
  primary:    '#1B365D', // azul marinho
  secondary:  '#A67C3B', // dourado
  accent:     '#3182CE', // azul médio (CTAs)
  background: '#F7FAFC',
  text:       '#2D3748',
  footerBg:   '#2C2C2C',
} as const;

export type TenantDefaultColorKey = keyof typeof TENANT_DEFAULT_COLORS;
